/**
 * @generated SignedSource<<1b6893df0231b69168088a360a046bfd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItems_notifications$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItems_notifications" | "NavItem_notifications">;
  readonly " $fragmentType": "NavItems_notifications";
};
export type NavItems_notifications$key = {
  readonly " $data"?: NavItems_notifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItems_notifications">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItems_notifications",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_notifications"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavExpandingAreaItems_notifications"
    }
  ],
  "type": "DealerNavBarBadges",
  "abstractKey": null
};

(node as any).hash = "88d968c144ef8abdb8916f177720a43a";

export default node;
